export default __webpack_public_path__ + "static/media/stereo_07.dd2e41e0.gif";